import { render, staticRenderFns } from "./MentalHealth.vue?vue&type=template&id=ccec7e12&scoped=true&"
import script from "./MentalHealth.vue?vue&type=script&lang=js&"
export * from "./MentalHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccec7e12",
  null
  
)

export default component.exports